import { Injectable } from '@angular/core';

import { IRewardToken } from '../reward-tokens.model';
import { IRewardTokenEligibility } from '../state';
import { isAccaBoostToken, isBetAndGetToken, isFreebetToken, isOddsBoostToken, isRiskFreeToken } from './reward-tokens.utils';
import { AccaBoostTokenValidator } from './validators/acca-boost-token-validator.service';
import { BetAndGetTokenValidator } from './validators/betandget-token-validator.service';
import { TokenValidationInput } from './validators/criteria-validator-base.service';
import { FreebetTokenValidator } from './validators/freebet-token-validator.service';
import { OddsBoostTokenValidator } from './validators/odds-boost-token-validator.service';
import { RiskFreeTokenValidator } from './validators/risk-free-token-validator.service';

@Injectable()
export class RewardTokensValidationService {
    constructor(
        private oddsBoostTokenValidator: OddsBoostTokenValidator,
        private riskFreeTokenValidator: RiskFreeTokenValidator,
        private freebetTokenValidator: FreebetTokenValidator,
        private betAndGetTokenValidator: BetAndGetTokenValidator,
        private accaBoostTokenValidator: AccaBoostTokenValidator,
    ) {}

    getTokenEligibilityStates(tokens: IRewardToken[], state: TokenValidationInput): IRewardTokenEligibility[] {
        // Consider refactoring the input per token type

        return tokens.map((token) => {
            if (isOddsBoostToken(token)) {
                return this.oddsBoostTokenValidator.validate(token, state);
            }

            if (isRiskFreeToken(token)) {
                return this.riskFreeTokenValidator.validate(token, state);
            }

            if (isFreebetToken(token)) {
                return this.freebetTokenValidator.validate(token, state);
            }

            if (isBetAndGetToken(token)) {
                return this.betAndGetTokenValidator.validate(token, state);
            }

            if (isAccaBoostToken(token)) {
                return this.accaBoostTokenValidator.validate(token, state);
            }

            throw new Error('Invalid token!');
        });
    }
}
